import styled from 'styled-components';

interface TitleProps {
  padding?: {
    top?: string | number;
    right?: string | number;
    bottom?: string | number;
    left?: string | number;
  };
  margin?: {
    top?: string | number;
    right?: string | number;
    bottom?: string | number;
    left?: string | number;
  };
  color?: string;
  fontSize?: number;
}

export const Title = styled.h1<TitleProps>`
  font-size: ${({ fontSize }) => `${fontSize}px` || '20px'};
  padding-top: ${({ padding }) => padding?.top || undefined};
  padding-right: ${({ padding }) => padding?.right || undefined};
  padding-bottom: ${({ padding }) => padding?.bottom || undefined};
  padding-left: ${({ padding }) => padding?.left || undefined};
  margin-top: ${({ margin }) => margin?.top || undefined};
  margin-right: ${({ margin }) => margin?.right || undefined};
  margin-bottom: ${({ margin }) => margin?.bottom || undefined};
  margin-left: ${({ margin }) => margin?.left || undefined};
  color: ${({ color, theme }) => color || theme.colors.black};
`;
